export default __webpack_public_path__ + "static/media/art_thumb.13f0404a.png";